import * as React from "react";
import classnames from "classnames";
import { useFormatter } from "@grandvisionhq/frk-routing";
import { Navigation } from "./Navigation.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const NavigationContainer = ({ currentStep, disabledSteps, isLoggedIn }) => {
  const query = new URLSearchParams(window.location.search);
  const checkoutSettings = useCheckoutSettings();
  const routes = checkoutSettings.routes ?? {};
  const formatter = useFormatter();
  const navigationRoutes = Object.entries(routes).filter(
    ([key]) => key !== "callback" && key !== "completed"
  );
  return /* @__PURE__ */ React.createElement("nav", { className: "checkout-nav" }, navigationRoutes.map(([step, route], index) => {
    const href = formatter({ route: `checkout.${step}`, query });
    const currentStepIndex = Object.keys(routes).indexOf(currentStep);
    const isDisabled = index > currentStepIndex || disabledSteps && disabledSteps.includes(step);
    const classNames = classnames("checkout-nav-step", {
      "checkout-nav-step--active": step === currentStep,
      "checkout-nav-step--disabled": isDisabled,
      "checkout-nav-step--completed": index < currentStepIndex && !isDisabled
    });
    return /* @__PURE__ */ React.createElement(
      Navigation,
      {
        href,
        classNames,
        index,
        isLoggedIn,
        key: step,
        route,
        isDisabled
      }
    );
  }));
};
export {
  NavigationContainer
};
//# sourceMappingURL=NavigationContainer.js.map
